import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import {documentTabLayoutTabs, TaskStatusIds, documentTypes} from '../../util/uiconstants';
import _, {isArray} from 'lodash';

/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function TaskDocumentsReducer(state = initialState.taskDocuments, action) {
	switch (action.type) {
		case types.GET_TASK_DOCUMENTS: {
			const {
				taskStatusId,
				isEPSignOffRequired,
				isEPSignOffUserRequired,
				isEQRSignOffRequired,
				isEQRSignOffUserRequired,
				evidences,
				temporaryfiles,
				prioryearevidences,
				externaldocuments
			} = state;
			let taskDocuments = action.response;
			const {hasEPSignOff, hasEQRSignOff} = taskDocuments;
			let taskId = action.response.taskId;
			let countName = 'Count';
			let evidenceCountProperty = `${taskId}${'_'}${documentTabLayoutTabs.evidenceName}${countName}`;
			let TemporaryCountProperty = `${taskId}${'_'}${documentTabLayoutTabs.temporaryName}${countName}`;
			let priorPeriodCountProperty = `${taskId}${'_'}${documentTabLayoutTabs.priorPeriodName}${countName}`;
			let externalDocumentCountProperty = `${taskId}${'_'}${documentTabLayoutTabs.externalDocsName}${countName}`;
			let groupDocumentCountProperty = `${taskId}${'_'}${documentTabLayoutTabs.groupDocsName}${countName}`;
			taskDocuments[evidenceCountProperty] = taskDocuments.evidencesCount;
			taskDocuments[TemporaryCountProperty] = taskDocuments.temporaryFilesCount;
			taskDocuments[priorPeriodCountProperty] = taskDocuments.priorYearEvidencesCount;
			taskDocuments[externalDocumentCountProperty] = taskDocuments.externalDocumentsCount;
			taskDocuments[groupDocumentCountProperty] =
				action.payload && action.payload.isV2Return
					? taskDocuments.groupDocumentsCount
					: state[groupDocumentCountProperty];

			return {
				...taskDocuments,
				taskStatusId: taskStatusId,
				evidences: evidences,
				temporaryfiles: temporaryfiles,
				prioryearevidences: prioryearevidences,
				externaldocuments: externaldocuments,
				isEPSignOffRequired: isEPSignOffRequired,
				isEPSignOffUserRequired: isEPSignOffUserRequired,
				isEQRSignOffRequired: isEQRSignOffRequired,
				isEQRSignOffUserRequired: isEQRSignOffUserRequired,
				isEPEQRSignoffComplete: calculateEPEQRSignoffComplete(
					taskStatusId,
					isEPSignOffRequired,
					isEPSignOffUserRequired,
					isEQRSignOffRequired,
					isEQRSignOffUserRequired,
					hasEPSignOff,
					hasEQRSignOff
				)
			};
		}
		case types.GET_TASK_DETAILS: {
			let taskDetails = action.response;
			const {
				taskStatusId,
				isEPSignoffRequired,
				isEPSignoffUserRequired,
				isEQRSignoffRequired,
				isEQRSignoffUserRequired
			} = taskDetails;
			const {hasEPSignOff, hasEQRSignOff} = state;
			return {
				...state,
				taskStatusId: taskStatusId,
				isEPSignOffRequired: isEPSignoffRequired,
				isEPSignOffUserRequired: isEPSignoffUserRequired,
				isEQRSignOffRequired: isEQRSignoffRequired,
				isEQRSignOffUserRequired: isEQRSignoffUserRequired,
				isEPEQRSignoffComplete: calculateEPEQRSignoffComplete(
					taskStatusId,
					isEPSignoffRequired,
					isEPSignoffUserRequired,
					isEQRSignoffRequired,
					isEQRSignoffUserRequired,
					hasEPSignOff,
					hasEQRSignOff
				)
			};
		}
		case 'DOCHELPER_UPLOAD_DOCUMENT':
			console.log('Update TaskDocument Evidences');
			let docPayloadInfo = action.meta.docHelper.docPayload;
			if (!docPayloadInfo || docPayloadInfo?.length === 0) {
				return state;
			}
			//entityToUpdate in the below line is defaulted to [0] index element since the docs can be uploaded only to one parent at a time
			let entityName = docPayloadInfo[0]?.parentName;
			let entityToUpdate = state[entityName];

			if (!action.isOnline) {
				action.response.map((item) => {
					let newDoc = docPayloadInfo.find(function(dp) {
						return dp.filePath == item.FileName;
					});
					newDoc.documentId = item.DocumentTransactionId;
					newDoc.documentTypeId = item.documentType;
					newDoc.inProgress = false;
				});
			}

			return state;

		case 'DOCUMENT_UPLOAD_COMPLETE':
		case 'DOCUMENT_UPLOAD_PROGRESS':
			if (action.meta && action.meta.docHelper) {
				const docPayload = action.meta.docHelper.payload;

				if (docPayload) {
					const parentName = docPayload.parentName;

					if (parentName) {
						const countProperty = parentName + 'Count';
						if (docPayload[countProperty]) {
							return {
								...state,
								[countProperty]: docPayload[countProperty]
							};
						}
					}
				}

				return state;
			}
			return state;
		case types.RESET_TASK_DETAIL:
			return {};
		case types.RESET_TASK_ATTRIBUTES:
			return {};
		case types.SEND_FILES_TO_DOCHELPER:
			return state;
		case types.TEMP_REMOVE_DOCUMENT:
			let newState = _.cloneDeep(state);
			switch (action.documentType) {
				case documentTypes.EVIDENCE:
					newState.evidences = state.evidences.filter((evidence) => evidence.documentId !== action.documentId);
					return newState;
				case documentTypes.CLIENTFILES:
				case documentTypes.AUTOMATIONHUBOUTPUT:
					newState.externaldocuments = state.externaldocuments.filter(
						(evidence) => evidence.documentId !== action.documentId
					);
					return newState;
				case documentTypes.CRASH:
					newState.temporaryfiles = state.temporaryfiles.filter(
						(evidence) => evidence.documentId !== action.documentId
					);
					return newState;
				case documentTypes.PRIORYEAREVIDENCE:
					newState.prioryearevidences = state.prioryearevidences.filter(
						(evidence) => evidence.documentId !== action.documentId
					);
					return newState;
				default:
					return state;
			}
		case types.ADD_DOCUMENTS_TO_TASKS:
			// taskId = state.taskId;
			if (
				action.payload &&
				action.response &&
				action.response.associatedTaskIds &&
				action.payload.taskIds &&
				action.payload.taskIds.length > 0
			) {
				let associatedTasksIds = action.response.associatedTaskIds;
				let currentTaskId = action.payload.taskIds[0];
				if (associatedTasksIds && associatedTasksIds.includes(currentTaskId)) {
					let documentCountPropertyName = `${currentTaskId}${'_'}${documentTabLayoutTabs.evidenceName}`;
					let updatesstate = resetCount(state, 1, documentCountPropertyName);
					return updatesstate;
				}

				return state;
			}

			return state;
		case types.UPDATE_DOCUMENT_METADATA:
			if (action.payload && action.payload.operationType == 'RefreshTaskDocument' && !action.error) {
				if (action.payload.parentName == documentTabLayoutTabs.temporaryName) {
					let documentCountPropertyName = `${action.payload.relatedEntityId}${'_'}${action.payload.parentName}`;
					let updatesstate = resetCount(state, 0, documentCountPropertyName);

					documentCountPropertyName = `${action.payload.relatedEntityId}${'_'}${documentTabLayoutTabs.evidenceName}`;
					updatesstate = resetCount(updatesstate, 1, documentCountPropertyName);

					return updatesstate;
				}
			}
			return state;
		case types.ASSOCIATE_TASK_DOCUMENTS:
			// Scenario: User might upload document to another task and can navigate to another task
			// below condition will check if the user is in the task to which the association is being performed
			// action.meta.api.data.TaskId is the task id to which the association is being performed
			// state.taskId is the task which the user is currently viewing.
			// return the existing state if the user is in a different task.
			let taskId =
				action.meta?.api?.data?.taskId ||
				action.meta.api.data.TaskId ||
				(action.meta.api.data.taskIds && action.meta.api.data.taskIds.length > 0 && action.meta.api.data.taskIds[0]);
			if (taskId !== state.taskId || action.error) {
				return state;
			}

			if (action.response && action.response.isDocumentNameAlreadyExists === true) {
				return state;
			}

			// if (!action.isOnline) {
			// 	return state;
			// }
			// If the user is in the same task add the document to the taskdocuments.
			let categoryName = action.meta.api.data.parentName || action.parentName;

			let documentsListKey = categoryName?.indexOf('_') > -1 ? categoryName?.split('_')[1] : `${categoryName}`;
			//let docInstate = state[categoryName].filter((d)=>doc.filename === action.response.documentName+'.'+action.response.fileExt);
			if (categoryName) {
				let countPropName =
					`${categoryName}`.indexOf('_') > -1 ? `${categoryName}` : `${taskId}${'_'}${categoryName}Count`;
				if (action.meta.api.data.operationType === 1 || action.operationType === 1) {
					let newApprovals = [];
					if (action.response.approvals) {
						newApprovals = [...action.response.approvals];
					}

					let newDoc = action.response.documentId
						? action.response
						: {
								id: action.meta?.api?.data?.DocumentId || action.documentId,
								documentId: action.meta?.api?.data?.DocumentId || action.documentId,
								documentName: getDocumentName(action.meta?.api?.data?.DocumentName || action.documentName),
								fileExt: getDocumentFileExtension(
									action.meta?.api?.data?.Documentfileext || action.documentfileext || action.documentName
								),
								documentTypeId:
									action.meta?.api?.data?.DocumentTypeId ||
									action.meta?.api?.data?.documentTypeId ||
									action.meta?.api?.data?.targetDocumentTypeId,
								engagementId: action.meta?.api?.data?.EngagementId || action.meta?.api?.data?.engagementId,
								relatedEntityId: taskId,
								signOffUsers: newApprovals,
								engagementReviewNoteCount: 0,
								gaComponentDocumentStatusID: !action.response.hasOwnProperty('gaComponentDocumentStatusID')
									? null
									: action.response.gaComponentDocumentStatusID,
								approvals: newApprovals && newApprovals.map((approval) => approval.id)
						  };

					let newState = state[documentsListKey]?.filter(
						(doc) => doc.documentName + '.' + doc.fileExt !== newDoc.documentName + '.' + newDoc.fileExt
					);

					const newDocCollection =
						(action.response.documentName && action.response.fileExt) || (newDoc.documentName && newDoc.fileExt)
							? [...newState, newDoc]
							: newState;

					return Object.assign(
						{},
						{
							...state,
							[documentsListKey]: newDocCollection,
							[countPropName]: _.chain(newDocCollection)
								.uniqBy('documentId')
								.size()
								.value()
						}
					);
				} else {
					//TODO: Operation type 2 for unaasociate
					// return state[categoryName].filter(
					// 	(doc) => doc.documentName != action.meta.api.data.DocumentName
					// );
					let updatedState = state;

					// if (
					// 	action.payload &&
					// 	action.payload.parentName == documentTabLayoutTabs.evidenceName &&
					// 	action.payload.functionType &&
					// 	action.payload.functionType.toUpperCase() == 'REMOVE'
					// ) {
					// 	let countPropertyName = `${state.taskId}${'_'}${action.payload.propertyUpdate}`;
					// 	updatesstate = resetCount(state, 1, countPropertyName);
					// }
					const newDocCollection = updatedState[documentsListKey].filter(
						(doc) => doc.documentId !== action.meta.api.data.DocumentId
					);

					updatedState = Object.assign({}, updatedState, {
						[categoryName]: newDocCollection
					});

					// Case when the document is being unassociated from its last remaining task and "moved" to temporary files
					if (action.payload?.propertyUpdate === documentTabLayoutTabs.temporaryName) {
						countPropName = getTaskDocumentCountName(taskId, action.payload?.propertyUpdate);
						const documentCount = updatedState[countPropName];
						updatedState = {
							...updatedState,
							[countPropName]: documentCount + 1
						};
					}

					return updatedState;
				}
			}

			return state;
		case types.REMOVE_TASK_DOCUMENT:
			//TODO: remove action.meta ? and send information shown below line
			//let category = action.meta.docHelper.payload.parentName;

			let category = action.meta ? action.meta.docHelper.payload.parentName : action.parentName;

			if (category && isArray(state[category])) {
				return Object.assign({}, state, {
					[category]: state[category]?.filter((doc) => doc.filename != action.documentName)
				});
			}
			return state;
		case types.ADD_APPROVAL_FOR_TASK:
			let newApprovalState = _.cloneDeep(state);
			if (_.isEmpty(newApprovalState)) {
				return state;
			}
			let addapprovalDoc = newApprovalState.evidences.find((doc) => doc.documentId == action.meta.api.data.documentId);
			if (!addapprovalDoc) {
				return state;
			}
			addapprovalDoc.isSignedOff = true;
			addapprovalDoc.signOffs
				? addapprovalDoc.signOffs.push(action.response)
				: (addapprovalDoc.signOffs = [action.response]);
			return Object.assign({}, state, newApprovalState);
		case types.DELETE_APPROVAL_FOR_TASK:
			let removeApprovalState = _.cloneDeep(state);
			if (_.isEmpty(removeApprovalState)) {
				return state;
			}
			let removeapprovalDoc = removeApprovalState.evidences.find(
				(doc) => doc.documentId == action.meta.api.data.documentId
			);
			if (!removeapprovalDoc) {
				return state;
			}
			removeapprovalDoc.signOffs = removeapprovalDoc.signOffs.filter(
				(signoff) => signoff.id != action.meta.api.data.approvalId
			);
			return Object.assign({}, state, removeApprovalState);
		case types.GET_TASK_DOCUMENTS_STATUS_FLAGS_ONLY:
			// Only take the fields coming from the API response.
			let taskDocumentsStatusAndFlags = action.response;
			let countName = 'Count';
			let idTask = action.response.taskId;
			let evidenceCountName = `${documentTabLayoutTabs.evidenceName}${countName}`;
			let temporaryCountName = `${documentTabLayoutTabs.temporaryName}${countName}`;
			let priorPeriodCountName = `${documentTabLayoutTabs.priorPeriodName}${countName}`;
			let externalDocumentCountName = `${documentTabLayoutTabs.externalDocsName}${countName}`;
			let groupDocumentCountName = `${documentTabLayoutTabs.groupDocsName}${countName}`;

			let evidenceCountProperty = `${idTask}${'_'}${evidenceCountName}`;
			let temperaroryCountProperty = `${idTask}${'_'}${temporaryCountName}`;
			let priorPeriodCountProperty = `${idTask}${'_'}${priorPeriodCountName}`;
			let externalDocumentCountProperty = `${idTask}${'_'}${externalDocumentCountProperty}`;

			let updateState = {
				...state,
				loggedInUserId: taskDocumentsStatusAndFlags.loggedInUserId,
				taskStatusId: taskDocumentsStatusAndFlags.taskStatusId,
				reHandOff: taskDocumentsStatusAndFlags.reHandOff,
				enableHandOff: taskDocumentsStatusAndFlags.enableHandOff,
				enableButton: taskDocumentsStatusAndFlags.enableButton,
				enableHandoffforPgat: taskDocumentsStatusAndFlags.enableHandoffforPgat,
				enableCompleteButton: taskDocumentsStatusAndFlags.enableCompleteButton,
				enableReturned: taskDocumentsStatusAndFlags.enableReturned,
				enableSendButton: taskDocumentsStatusAndFlags.enableSendButton,
				isEPEQRSignoffComplete: taskDocumentsStatusAndFlags.isEPEQRSignoffComplete,
				isEPSignOffRequired: taskDocumentsStatusAndFlags.isEPSignOffRequired,
				isEQRSignOffRequired: taskDocumentsStatusAndFlags.isEQRSignOffRequired,
				isEPSignOffUserRequired: taskDocumentsStatusAndFlags.isEPSignOffUserRequired,
				isEQRSignOffUserRequired: taskDocumentsStatusAndFlags.isEQRSignOffUserRequired,
				isDocumentsInTransit: taskDocumentsStatusAndFlags.istaskDocumentsStatusAndFlagsDocumentsInTransit,
				hasEQRSignOff: taskDocumentsStatusAndFlags.hasEQRSignOff,
				hasEPSignOff: taskDocumentsStatusAndFlags.hasEPSignOff
			};

			updateState[evidenceCountProperty] =
				action.response[evidenceCountName] != undefined
					? action.response[evidenceCountName]
					: updateState[evidenceCountProperty];
			updateState[temperaroryCountProperty] =
				action.response[temporaryCountName] != undefined
					? action.response[temporaryCountName]
					: updateState[temperaroryCountProperty];
			updateState[priorPeriodCountProperty] =
				action.response[priorPeriodCountName] != undefined
					? action.response[priorPeriodCountName]
					: updateState[priorPeriodCountProperty];
			updateState[externalDocumentCountProperty] =
				action.response[externalDocumentCountName] != undefined
					? action.response[externalDocumentCountName]
					: updateState[externalDocumentCountProperty];

			return updateState;
		case types.GET_DOCUMENT_LIST:
			// I have the response from document list. I need to update the redux store for the counts of the respective document tab
			let mapper = {
				evidence: documentTabLayoutTabs.evidenceName,
				temporary: documentTabLayoutTabs.temporaryName,
				prioryear: documentTabLayoutTabs.priorPeriodName,
				external: documentTabLayoutTabs.externalDocsName,
				ComponentGroup: documentTabLayoutTabs.groupDocsName
			};

			let documentCategoryName = action.filters.props.documentCategoryName;
			let parentName = mapper[documentCategoryName];
			if (action?.parentName?.indexOf('regionComponent') > -1) {
				return state;
			}
			parentName = `${parentName}Count`;
			taskId = action.filters.props.filteredEntityIdGuid;
			let countPropertyName = `${taskId}${'_'}${parentName}`;
			let documentsListName = `${mapper[documentCategoryName]}`;
			let documentList = [];
			if (action.filters && action.response.data) {
				documentList = constructList(action, state, 'signOffUsers');
			}
			return {
				...state,
				[countPropertyName]: _.size(action?.response?.data),
				[documentsListName]: documentList
			};
		case types.ADD_DOCUMENT_TO_EVIDENCE: {
			if (action.payload) {
				const taskId = action.payload.taskId;
				const evidenceCountProperty = `${taskId}${'_'}${documentTabLayoutTabs.evidenceName}Count`;
				const newDocument = {
					documentId: action.payload.document.id,
					...action.payload.document
				};

				let evidenceList = state.evidences || [];
				let evidenceCount = state[evidenceCountProperty] || 0;

				if (newDocument) {
					if (!state.evidences?.find((doc) => doc.documentId === newDocument.documentId)) {
						evidenceList = evidenceList.concat(newDocument);
						evidenceCount++;
					}

					return {
						...state,
						evidences: evidenceList,
						[evidenceCountProperty]: evidenceCount
					};
				}
			}

			return state;
		}

		default:
			return state;
	}
}

function getDocumentName(document) {
	if (document && document.indexOf('.') > -1) {
		return document.split('.').slice(0, -1)[0];
	}
}

function getDocumentFileExtension(document) {
	if (document) {
		return document.split('.').pop();
	}
}

function constructList(action, state, key) {
	let evidenceList = [];
	for (let i = 0; i < action.response.data.length; i++) {
		let document = action.response.data[i];
		let newDocument = {
			documentId: document.id,
			documentName: document.documentName,
			fileExt: document.fileExt,
			documentTypeId: document.documentTypeId,
			signOffs: document[key]
		};

		evidenceList.push(newDocument);
	}
	return evidenceList;
}

function resetCount(state, operationType, tabname) {
	const countPropName = `${tabname}Count`;
	let countEvidenec = state[countPropName];
	if (!_.isUndefined(countEvidenec)) {
		return Object.assign({}, state, {
			[countPropName]: operationType ? countEvidenec + 1 : countEvidenec - 1
		});
	}
	return state;
}

function calculateEPEQRSignoffComplete(
	taskStatusId,
	isEPSignoffRequired,
	isEPSignoffUserRequired,
	isEQRSignoffRequired,
	isEQRSignoffUserRequired,
	hasEPSignOff,
	hasEQRSignOff
) {
	let isEPEQRSignoffComplete = false;
	if (taskStatusId === TaskStatusIds.Complete) {
		if ((isEQRSignoffRequired || isEQRSignoffUserRequired) && (isEPSignoffRequired || isEPSignoffUserRequired)) {
			isEPEQRSignoffComplete = hasEQRSignOff && hasEPSignOff;
		} else if (isEQRSignoffRequired || isEQRSignoffUserRequired) {
			isEPEQRSignoffComplete = hasEQRSignOff;
		} else {
			if (isEPSignoffRequired || isEPSignoffUserRequired) {
				isEPEQRSignoffComplete = hasEPSignOff;
			}
		}
	}

	return isEPEQRSignoffComplete;
}

export function getTaskDocumentCountKey(taskId, tabName) {
	let taskDocumentCountKey = taskId ? `${taskId}_` : '';
	if (!tabName) {
		return undefined;
	}
	return `${taskDocumentCountKey}${tabName}`;
}

export function getTaskDocumentCountName(taskId, tabName) {
	let countKey = getTaskDocumentCountKey(taskId, tabName);
	return countKey ? `${countKey}Count` : undefined;
}
